// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poe {
  margin-top: 1.25rem;
  padding-top: 0.875rem;
  border-top: 1px solid #e5e7eb;
}

.poe-header {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #9ca3af;
  padding-bottom: 0.4rem;
  margin-bottom: 0.6rem;
  border-bottom: 1px solid #f0f0f0;
}

.poe-note {
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 0.6rem;
}

.poe-note--warn {
  color: #b45309;
}

.poe-row {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.5rem 0.25rem;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  margin: 0;
}

.poe-row:last-child {
  border-bottom: none;
}

.poe-row .form-check-input {
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.poe-row--locked {
  cursor: not-allowed;
  opacity: 0.75;
}

.poe-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.poe-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #1c2127;
}

.poe-number {
  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);
  color: #6b7280;
  margin-right: 0.25rem;
}

.poe-meta {
  font-size: 0.75rem;
  color: #6b7280;
}

.poe-meta--locked {
  color: #b45309;
  margin-top: 0.15rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/payee-other-entries/payee-other-entries.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oEAAoE;EACpE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".poe {\n  margin-top: 1.25rem;\n  padding-top: 0.875rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.poe-header {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #9ca3af;\n  padding-bottom: 0.4rem;\n  margin-bottom: 0.6rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.poe-note {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-bottom: 0.6rem;\n}\n\n.poe-note--warn {\n  color: #b45309;\n}\n\n.poe-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  padding: 0.5rem 0.25rem;\n  border-bottom: 1px solid #f3f4f6;\n  cursor: pointer;\n  margin: 0;\n}\n\n.poe-row:last-child {\n  border-bottom: none;\n}\n\n.poe-row .form-check-input {\n  margin-top: 0.2rem;\n  flex-shrink: 0;\n}\n\n.poe-row--locked {\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n.poe-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.poe-name {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1c2127;\n}\n\n.poe-number {\n  font-family: var(--sms-font-display, 'Barlow Condensed', sans-serif);\n  color: #6b7280;\n  margin-right: 0.25rem;\n}\n\n.poe-meta {\n  font-size: 0.75rem;\n  color: #6b7280;\n}\n\n.poe-meta--locked {\n  color: #b45309;\n  margin-top: 0.15rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
